import type { Partner } from '@/data'
import api from '..'
import type { PartnerPayload } from './createPartner'

export async function updatePartner(
  id: string,
  payload: Partial<PartnerPayload>,
): Promise<Partner> {
  const res = await api.put(`/partners/${id}`, payload)
  return res.data.data
}
